import { render } from "./SgOneClickWidget.vue?vue&type=template&id=5b00dadc"
import script from "./SgOneClickWidget.vue?vue&type=script&lang=js"
export * from "./SgOneClickWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__